module.exports = __webpack_public_path__ + "img/border5.f1ec87ad.png";